import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";
import { connectFirestoreEmulator, getFirestore } from "firebase/firestore";
import { connectStorageEmulator, getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

// Nenhum valor acima e segredo (config web do Firebase vai no bundle por
// design, ver .env.example na raiz do repo). Quem protege o dado e o
// firestore.rules, nao o sigilo desta config.
export const firebaseConfigured = Boolean(
  firebaseConfig.apiKey && firebaseConfig.projectId && firebaseConfig.appId,
);

if (!firebaseConfigured) {
  console.error(
    "VITE_FIREBASE_* ausentes. Copie .env.example para .env.local na raiz do " +
      "repo e preencha com os dados do projeto Firebase, ou rode contra o " +
      "emulador (ver package.json).",
  );
}

export const app = initializeApp(
  firebaseConfigured
    ? firebaseConfig
    : { apiKey: "demo-key", projectId: "demo-cafelabs-admin", appId: "demo-app" },
);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// VITE_USE_FIREBASE_EMULATOR=true liga o front contra `firebase emulators:start`
// (Firestore :8085, Auth :9099, Storage :9199) em vez do projeto real — usado
// em desenvolvimento local antes de existir um projeto Firebase provisionado
// de verdade. Nunca ligado em build de producao (a env var nao existe la).
if (import.meta.env.VITE_USE_FIREBASE_EMULATOR === "true") {
  connectFirestoreEmulator(db, "127.0.0.1", 8085);
  connectAuthEmulator(auth, "http://127.0.0.1:9099", { disableWarnings: true });
  connectStorageEmulator(storage, "127.0.0.1", 9199);
}
